import { lazy } from 'react';
import i18next from 'i18next';
import { QhslabDocsIcon } from '@shared/ui/icons';

const QhslabDocuments = lazy(() => import('../../../../../pages/qhslab-documents'));

// No permission gate: the QHSLAB document library is available to
// every authenticated account (unlike AllergiEnd Documents, which is
// gated by ACCOUNT_GET_ALLERGIEND_RESOURCES).
const QHSLAB_DOCUMENTS_DASHBOARD = {
  path: '/:currentAccountUuid/qhslab-documents',
  exact: true,
  additional: {
    component: QhslabDocuments,
    protected: true,
    title: i18next.t('titles:qhslabDocuments'),
    icon: QhslabDocsIcon,
    breadcrumb: {
      isRoot: true,
      label: ({ state }) => state.i18n?.en?.titles?.qhslabDocuments || 'QHSLAB Documents',
    },
  },
};

export const QHSLAB_DOCUMENTS_ROUTES = {
  dashboard: QHSLAB_DOCUMENTS_DASHBOARD,
};
